var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandbag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2628 11.8125H7.73726C7.41426 11.8125 7.10261 11.9316 6.86193 12.147C6.62125 12.3624 6.46846 12.659 6.43279 12.9801L4.09946 33.9801C4.07907 34.1635 4.09762 34.3492 4.15388 34.525C4.21013 34.7008 4.30284 34.8628 4.42595 35.0003C4.54906 35.1379 4.69979 35.2479 4.86831 35.3232C5.03683 35.3986 5.21934 35.4375 5.40393 35.4375H36.5961C36.7807 35.4375 36.9632 35.3986 37.1317 35.3232C37.3002 35.2479 37.451 35.1379 37.5741 35.0003C37.6972 34.8628 37.7899 34.7008 37.8462 34.525C37.9024 34.3492 37.921 34.1635 37.9006 33.9801L35.5672 12.9801C35.5316 12.659 35.3788 12.3624 35.1381 12.147C34.8974 11.9316 34.5858 11.8125 34.2628 11.8125Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 17.0625V11.8125C14.4375 10.072 15.1289 8.40282 16.3596 7.17211C17.5903 5.9414 19.2595 5.25 21 5.25C22.7405 5.25 24.4097 5.9414 25.6404 7.17211C26.8711 8.40282 27.5625 10.072 27.5625 11.8125V17.0625",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandbag);
export default __webpack_public_path__ + "static/media/handbag.e0dff90fdab56b15b750fb576fe2d58c.svg";
export { ForwardRef as ReactComponent };